import { useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '@/utils/api'

type Args = {
  accountUserId: string
  primaryUserId: string
}

export const useUnlinkAccount = () => {
  const queryClient = useQueryClient()

  return useMutation<{ success: boolean }, Error, Args>({
    mutationFn: async ({ accountUserId, primaryUserId }) => {
      const { data } = await api.post('/users/unlink-account', {
        accountUserId,
        primaryUserId,
      })
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['linked-accounts'] })
      queryClient.invalidateQueries({ queryKey: ['me'] })
    },
  })
}
